import React from 'react';

import { Box, ComposableTypography, Typography, useTheme } from '@bcp-nextgen-dx-component-factory/design-system';
import { Call } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { Link } from '@components';
import { rem } from '@helpers';
import { ROUTES } from '@navigation';

import { useDoubtsAndExit } from './doubtsAndExit.helper';

export const DoubtsAndExit: React.FC = () => {
	const { colorPalette } = useTheme();
	const { resources, onHandleLink, onHandleLinkExit } = useDoubtsAndExit();
	return (
		<Box styles={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
			<Box styles={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }} />
			<Box styles={{ display: 'flex', flexDirection: 'column' }}>
				<Box
					styles={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
					}}
				>
					<Call fill={colorPalette.color_02[100]} />
					<Link onClick={onHandleLink}>
						<ComposableTypography
							text={resources.hasDoubtsAndTalkWithUs}
							baseProps={{
								appearance: 'body-100-03',
								colorToken: 'primary-light',
								colorsLevel: 'linkDefault',
							}}
							tags={{
								highlight: {
									appearance: 'body-100-04',
									colorsLevel: 'linkDefault',
									colorToken: 'primary-light',
								},
							}}
						/>
					</Link>
				</Box>
				<Box
					styles={{
						display: 'flex',
						flexDirection: 'column',
						margin: rem(16, 0, 16, 0),
						height: '1px',
						background: '#D8D9E1',
						width: '100%',
					}}
				/>
				<Box styles={{ display: 'flex', flexDirection: 'row', paddingLeft: rem(16) }}>
					<Link onClick={onHandleLinkExit}>
						<Typography appearance="body-100-02" colorsLevel="neutralPrimary">
							{resources.exit}
						</Typography>
					</Link>
				</Box>
			</Box>
		</Box>
	);
};
